// src/store.ts
import { Middleware } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import rootReducers from "./rootReducers";
import { clearUser } from "./slices/userSlice";

const middlewares: Middleware[] = [];

export const store = configureStore({
  reducer: rootReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middlewares),
});

export const persistor = persistStore(store);

window.addEventListener("storage", (event) => {
  if (
    event.storageArea === localStorage &&
    !localStorage.getItem("persist:Artgapi_Web")
  ) {
    store.dispatch(clearUser());
    persistor.purge();
  }
});

const exportStore = { store, persistor };

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default exportStore;
